import { Transaction } from '@enter/core';
import { IItemDetail, IItemListing } from './root.store';

export type TransactionListingRequest = {
    limit?: number;
    offset?: number;
    sort?: string[];
    order?: ('ASCENDING' | 'DESCENDING')[];
} & Record<string, unknown>;

export class TransactionService {
    public async fetchTransactionListing(
        _lpgr: TransactionListingRequest,
    ): Promise<IItemListing<Transaction> | undefined> {
        return {
            items: [],
            limit: 0,
            offset: 0,
            total: 0,
        };
    }
    public async fetchTransaction(_id: string): Promise<Transaction | undefined> {
        return undefined;
    }
    public async fetchTransactionDetail(_guarantorId: string): Promise<IItemDetail<Transaction> | undefined> {
        return undefined;
    }
}
